import { render, staticRenderFns } from "./TaxonomyRemoveModal.vue?vue&type=template&id=b76fb626&scoped=true&"
import script from "./TaxonomyRemoveModal.vue?vue&type=script&lang=js&"
export * from "./TaxonomyRemoveModal.vue?vue&type=script&lang=js&"
import style0 from "./TaxonomyRemoveModal.vue?vue&type=style&index=0&id=b76fb626&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b76fb626",
  null
  
)

export default component.exports